// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"styles_checkBox__8m5k7","formGroup":"styles_formGroup__1fzWy","input":"styles_input__2ZuxJ"};